
export interface AuthenticationModalInitialState {
    showQR?:boolean;
    qrData?:string;
    token?:string;
    enabled: boolean;
    onSuccess?:(e?:any) => void;
    onError?:(e?:any) => void;
}

export default {
    showQR:false,
    enabled: false,
} as AuthenticationModalInitialState;